import React, { useRef, useEffect } from 'react';
import campoFrescoVideo from '../assets/videos/CampoFresco.mov';

export default function VideoInfoSection() {
  const videoRef = useRef(null);

  // Effect para manejar eventos de pantalla completa
  useEffect(() => {
    const video = videoRef.current;
    if (video) {
      const handleFullscreenChange = () => {
        // Si estamos en pantalla completa, reiniciar y reproducir
        if (document.fullscreenElement === video || 
            document.webkitFullscreenElement === video || 
            document.msFullscreenElement === video) {
          video.currentTime = 0;
          video.play();
        }
      };

      // Agregar event listeners para diferentes navegadores
      document.addEventListener('fullscreenchange', handleFullscreenChange);
      document.addEventListener('webkitfullscreenchange', handleFullscreenChange);
      document.addEventListener('msfullscreenchange', handleFullscreenChange);

      return () => {
        document.removeEventListener('fullscreenchange', handleFullscreenChange);
        document.removeEventListener('webkitfullscreenchange', handleFullscreenChange);
        document.removeEventListener('msfullscreenchange', handleFullscreenChange);
      };
    }
  }, []);
  // Pantalla completa
  const handleFullscreen = async () => {
    const video = videoRef.current;
    if (video) {
      try {
        // Entrar a pantalla completa
        if (video.requestFullscreen) {
          await video.requestFullscreen();
        } else if (video.webkitRequestFullscreen) {
          video.webkitRequestFullscreen();
        } else if (video.msRequestFullscreen) {
          video.msRequestFullscreen();
        }
      } catch (error) {
        console.log('Error al entrar en pantalla completa:', error);
      }
    }
  };

  return (
    <div className="w-full">
      <section className="py-16 px-4 bg-white">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-12">
            <h2 className="text-3xl md:text-4xl font-bold text-gray-800 mb-4">
              Conoce nuestro proceso de selección
            </h2>
            <p className="text-lg text-gray-600 max-w-2xl mx-auto">
              Descubre cómo seleccionamos cada producto para garantizar 
              la máxima frescura y calidad que llega hasta tu hogar.
            </p>
          </div>
          <div className="relative max-w-4xl mx-auto">
            <div className="relative bg-gray-900 rounded-2xl overflow-hidden shadow-2xl aspect-video">
              <video
                ref={videoRef}
                src={campoFrescoVideo}
                className="w-full h-full object-cover"
                autoPlay
                muted
                controls
                controlsList="nodownload"
                onDoubleClick={handleFullscreen}
                loop
              />
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}